import React, { useState } from 'react';
import { FaBars, FaChevronDown, FaTimes } from 'react-icons/fa';
// import logo from '../../images/logo/unnamed.png';
import logo from '../../images/logo/header-logo.jpg';
import '../../index.css'
import '../../App.css'
import DelegateRegistration from './DelegateRegister';
import { useNavigate } from 'react-router-dom';
import RouteConstants from '../../constant/Routeconstant';
import TopHeader from './TopHeader';
import { useSelector } from 'react-redux';

const MainHeader = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const navigate = useNavigate();

      const accessToken = useSelector((state) => state.leads.leadData.token);
    
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleDropdown = (dropdown) => {
        setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
    };

    return (
        <header className="bg-white shadow-lg sticky top-0 z-40 mainHeader">
            <div className="container mx-auto px-4">
                <nav className="flex items-center justify-between py-4 mainHeaderNav">
                    {/* Logo */}
                    <a href="/" className="flex-shrink-0">
                        <img
                            // src="/img/logos/logo.png"
                            src={logo}
                            alt="ILFK-KSA Logo"
                            className="h-8 md:h-12 w-auto"
                        />
                    </a>

                    {/* Mobile Menu Button */}
                    <button
                        onClick={toggleMenu}
                        className="lg:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                    >
                        {isMenuOpen ? <FaTimes className="h-6 w-6" /> : <FaBars className="h-6 w-6" />}
                    </button>

                    {/* Desktop Navigation */}
                    <div className="hidden lg:flex lg:items-center lg:space-x-8">
                        {/* Index Dropdown */}
                        <div className="relative group">
                            <button
                                onClick={() => navigate(RouteConstants.ROOT)}
                                className="flex items-center text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                            // onClick={() => toggleDropdown('index')}
                            >
                                Home
                            </button>
                        </div>

                        {/* Listings Dropdown */}
                        {/* <div className="relative group">
                            <button
                                className="flex items-center text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                            // onClick={() => toggleDropdown('listings')}
                            >
                                About
                            </button>
                        </div> */}  

                        {/* Agents Dropdown */}
                        <div className="relative group">
                            <button
                                onClick={() => navigate(RouteConstants.SPEAKERLISTSITEILFK)}
                                className="flex items-center text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                            >
                                Speakers
                            </button>
                            {/* <div className="absolute top-full left-0 w-48 bg-white shadow-lg rounded-md py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                                <a href="/agent-grid" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Agent Grid 1</a>
                                <a href="/agent-grid-2" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Agent Grid 2</a>
                                <a href="/agent-list" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Agent List 1</a>
                                <a href="/agent-detail" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Agent Details</a>
                            </div> */}
                        </div>

                        {/* Pages Megamenu */}
                        <div className="relative group">
                            <button
                                onClick={() => navigate(RouteConstants.NEWSLISTILFK)}
                                className="flex items-center text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                            >
                                News
                            </button>
                        </div>

                        {/* Blog Dropdown */}
                        <div className="relative group">
                            <button
                                onClick={() => navigate(RouteConstants.VIDEOSLISTILFK)}
                                className="flex items-center text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                            >
                                Videos
                                {/* <FaChevronDown className="ml-1 text-xs" /> */}
                            </button>
                            {/* <div className="absolute top-full left-0 w-48 bg-white shadow-lg rounded-md py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                                <a href="/blog" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Blog Grid</a>
                                <a href="/blog-list" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Blog List</a>
                                <a href="/blog-detail" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Blog Details</a>
                            </div> */}
                        </div>

                        {/* Contact Dropdown */}
                        <div className="relative group">
                            <button
                                onClick={() => navigate(RouteConstants.PHOTOGALERYLISTILFK)}
                                className="flex items-center text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                            >
                                Photos
                            </button>
                        </div>

                        {/* Sessions Dropdown */}
                        <div className="relative group">
                            <button
                                onClick={() => navigate(RouteConstants.SESSIONSSITEILFK)}
                                className="flex items-center text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                            >
                                Sessions
                            </button>
                        </div>
                        <div className="relative group">
                            {accessToken ? (
                                <button
                                onClick={() => navigate(RouteConstants.LEADDASH)}
                                className="flex items-center text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                                >
                                Dashboard
                                </button>
                            ) : (
                                <button
                                onClick={() => navigate(RouteConstants.LEADLOGIN)}
                                className="flex items-center text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                                >
                                Delegate Login
                                </button>
                            )}
                            </div>


                        {/* Submit Property Button */}
                        {/* <a
                            href="/delegate-register"
                            className="bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700 transition-colors"
                        >
                            Delegate Register
                        </a> */}
                        {/* <DelegateRegistration /> */}
                    </div>
                </nav>

                {/* Mobile Navigation */}
                <div className={`lg:hidden ${isMenuOpen ? 'block' : 'hidden'} border-t border-gray-200 py-4 mainHeaderPH`}>
                    <div className="space-y-4">
                        {/* Mobile Index Dropdown */}
                        <div className='md:hidden rounded-md'>
                            <TopHeader />
                        </div>
                        <div>
                            <button
                                className="flex items-center justify-between w-full text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                                onClick={() => navigate(RouteConstants.ROOT)}
                            >
                                Home
                            </button>
                        </div>

                        {/* Mobile Listings Dropdown */}
                        {/* <div>
                            <button
                                className="flex items-center justify-between w-full text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                                onClick={() => toggleDropdown('mobile-listings')}
                            >
                                About
                            </button>
                        </div> */}

                        {/* Mobile Agents Dropdown */}
                        <div>
                            <button
                                className="flex items-center justify-between w-full text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                                onClick={() => navigate(RouteConstants.SPEAKERLISTSITEILFK)}
                            >
                                Speakers
                            </button>
                        </div>

                        {/* Mobile Pages Dropdown */}
                        <div>
                            <button
                                className="flex items-center justify-between w-full text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                                onClick={() => navigate(RouteConstants.NEWSLISTILFK)}
                            >
                                News
                            </button>
                        </div>

                        {/* Mobile Blog Dropdown */}
                        <div>
                            <button
                                onClick={() => navigate(RouteConstants.VIDEOSLISTILFK)}
                                className="flex items-center justify-between w-full text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                            >
                                Videos
                            </button>
                        </div>

                        {/* Mobile Contact Dropdown */}
                        <div>
                            <button
                                className="flex items-center justify-between w-full text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                                onClick={() => navigate(RouteConstants.PHOTOGALERYLISTILFK)}
                            >
                                Photos
                            </button>
                        </div>

                        {/* Contact Dropdown */}
                        <div>
                            <button
                                className="flex items-center justify-between w-full text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                                onClick={() => navigate(RouteConstants.SESSIONSSITEILFK)}
                            >
                                Sessions
                                {/* <FaChevronDown className={`ml-1 text-xs transition-transform ${activeDropdown === 'mobile-contact' ? 'rotate-180' : ''}`} /> */}
                            </button>
                            {/* <div className={`pl-4 space-y-2 ${activeDropdown === 'mobile-contact' ? 'block' : 'hidden'}`}>
                                <a href="/contact" className="block text-gray-600 hover:text-blue-600 py-1">Contact 1</a>
                                <a href="/contact-2" className="block text-gray-600 hover:text-blue-600 py-1">Contact 2</a>
                                <a href="/contact-3" className="block text-gray-600 hover:text-blue-600 py-1">Contact 3</a>
                            </div> */}
                        </div>
                        {/* mobile login button */}
                        <div>
                            {accessToken ? (
                                <button
                                onClick={() => navigate(RouteConstants.LEADDASH)}
                                className="flex items-center justify-between w-full text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                                >
                                Dashboard
                                </button>
                            ) : (
                                <button
                                onClick={() => navigate(RouteConstants.LEADLOGIN)}
                                className="flex items-center justify-between w-full text-[#000] hover:text-[#e1332c] py-2 transition-colors"
                                >
                                Delegate Login
                                </button>
                            )}
                            </div>

                        {/* Mobile Submit Property Button */}
                        <div className="pt-4">
                            {/* <a
                                href="#"
                                className="block w-full text-center bg-blue-600 text-white px-6 py-3 rounded-full hover:bg-blue-700 transition-colors"
                            >
                                Delegate Register
                            </a> */}
                            {/* <DelegateRegistration /> */}
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default MainHeader;
